import Vue from 'vue'
import AppToast from '../components/UI/AppToast.vue'

const ToastPlugin = {
  install (Vue) {
    // Crea una instancia del contenedor de toasts montada en el body, compartida
    // por toda la app. De esta forma se puede llamar `this.$toast.show('msg', opts)`,
    // `this.$toast.success('msg')`, `this.$toast.danger('msg')`, etc. desde cualquier
    // componente.
    const ToastConstructor = Vue.extend(AppToast)
    const instance = new ToastConstructor()
    instance.$mount()
    document.body.appendChild(instance.$el)

    Vue.prototype.$toast = instance
  }
}

Vue.use(ToastPlugin)

export default ToastPlugin
